// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"686aeeeb","570":"136b0417","787":"55872042","948":"0cfc0d68"}[chunkId] + ".chunk.js";
};